import { getDictPhrase } from "../../../common";
export const getBetStakeSystemBetProps = (bet, state) => {
    const totalAmount = state.formatCurrency(bet.totalStake);
    const unitStake = state.formatCurrency(bet.unitStake);
    const stakeDetails = getDictPhrase(state.dict, "SystemStakeDetails").format(bet.numberOfBets, unitStake);
    return {
        phrase: getDictPhrase(state.dict, "Stake"),
        amount: `${totalAmount} ${stakeDetails}`
    };
};
//# sourceMappingURL=getBetStakeSystemBetProps.js.map